//import { useEffect, useState } from 'react';
//import { userService } from '../../services/UserService';
import { Link } from 'react-router-dom';

function ActivationHelpPage() {
  return (
    <div
      className='d-flex flex-column shadow bordered rounded p-3'
      style={{ minHeight: '300px' }}
    >
      <h2>Активация игры</h2>
      <div>
        <small className='fw-bold mb-2'>
          В качестве примера расскажем про активацию ключа для Steam.
        </small>
        <p>
          Steam — это многофункциональный сервис цифрового распространения
          компьютерных игр и программ, принадлежащий компании Valve и
          пользующийся спросом миллионов пользователей по всему миру.
        </p>
        <p>
          Ваш ключ активации всегда находится в разделе{' '}
          <Link
            className='text-dark fw-bold'
            to={'/profile/purchases'}
            style={{ textDecoration: 'none' }}
          >
            "Мои покупки"
          </Link>{' '}
          .
        </p>
        <p>Ключ представляется в виде цифробуквенного кода.</p>
        <p>
          <b>1.</b> Скачайте клиент Steam с официального сайта и установите.
        </p>
        <p>
          <b>2.</b> После установки введите логин и пароль от вашей учетной
          записи, либо создайте новую, и войдите в свой аккаунт.
        </p>
        <p>
          <b>3.</b> В меню "Игры" выберите пункт "Активировать через Steam". В
          появившемся окошке нажмите "Далее" и согласитесь с "Соглашением
          подписчика службы Steam".
        </p>
        <p>
          <b>4.</b>. Активируйте полученный после покупки ключ активации.
        </p>
        <p>
          <b>5.</b> После активации установите игру и играйте в своё
          удовольствие!
        </p>
        <p>
          <b>6.</b> Ключ можно активитировать и через браузер. Входите в свой
          аккаунт через браузер и проделываете прошлые этапы.
        </p>
      </div>
    </div>
  );
}

export default ActivationHelpPage;
